import { PHONE_DISPLAY } from "../../i18n/translations";

export const Footer = ({ t }) => {
  const year = new Date().getFullYear();
  return (
    <footer
      data-testid="site-footer"
      className="bg-zinc-950 border-t border-zinc-900 pt-16 pb-10"
    >
      <div className="max-w-7xl mx-auto px-6 md:px-12">
        <div className="grid grid-cols-1 md:grid-cols-12 gap-10">
          <div className="md:col-span-5">
            <div className="flex items-center gap-3">
              <img
                src="/brand/tcars-logo.png"
                alt="T-CARS Garaje"
                className="h-12 w-auto object-contain"
              />
              <span className="font-body text-[10px] font-bold tracking-[0.25em] uppercase text-zinc-500 border-l border-zinc-800 pl-3">
                2019 S.L.
              </span>
            </div>
            <p className="font-body mt-5 text-sm text-zinc-500 max-w-sm">
              {t.footer.tagline}
            </p>
          </div>

          <div className="md:col-span-3">
            <span className="font-body text-[10px] font-bold tracking-[0.3em] uppercase text-zinc-600">
              {t.footer.company_label}
            </span>
            <p className="font-heading mt-3 text-sm text-zinc-300">
              T-CARS GARAGE 2019 S.L.
            </p>
            <span className="block mt-5 font-body text-[10px] font-bold tracking-[0.3em] uppercase text-zinc-600">
              {t.footer.activity_label}
            </span>
            <p className="font-body mt-2 text-sm text-zinc-400">
              {t.footer.activity}
            </p>
          </div>

          <div className="md:col-span-4">
            <span className="font-body text-[10px] font-bold tracking-[0.3em] uppercase text-zinc-600">
              {t.nav.contact}
            </span>
            <p className="font-body mt-3 text-sm text-zinc-400 leading-relaxed">
              Cami de Can Guasch, 5, Nave 3
              <br />
              08150 Parets del Vallès, Barcelona
            </p>
            <p className="font-heading mt-3 text-base text-zinc-100">
              {PHONE_DISPLAY}
            </p>
          </div>
        </div>

        <div className="mt-14 pt-6 border-t border-zinc-900 flex flex-col md:flex-row items-start md:items-center justify-between gap-3">
          <p className="font-body text-xs text-zinc-600">
            © {year} T-CARS GARAGE 2019 S.L. {t.footer.rights}
          </p>
          <p className="font-body text-[10px] text-zinc-700 tracking-[0.2em] uppercase">
            Parets del Vallès · Barcelona · España
          </p>
        </div>
      </div>
    </footer>
  );
};
